<template>
  <div id="main-page">

     <v-dialog v-model="showGrade" max-width="900px" attach="#main-page" >
        <view-grade
            v-if="showGrade "
            :graded_lead="selectedLead"
            @close-parent="showGrade=false"
        ></view-grade>
     </v-dialog>


     <v-dialog v-model="showViewCoachup" max-width="900px" attach="#main-page" >
        <view-coachup
            v-if="showViewCoachup"
            :coachup="selectedCoachup"
            @close-parent="showViewCoachup=false"
        ></view-coachup>
     </v-dialog>



     <!--<v-dialog v-model="editGrade" max-width="1200px" persistent >-->
     <!--   <div style="background-color: white">-->
     <!--      <div style="justify-content: flex-end; display: flex; margin-bottom: -20px">-->
     <!--         <v-btn icon @click="close_edit_dialog()">-->
     <!--            <v-icon>close</v-icon>-->
     <!--         </v-btn>-->
     <!--      </div>-->
     <!--      <edit-grade-->
     <!--          v-if=" editGrade"-->
     <!--          :grade_id="selectedLead._id"-->
     <!--          @close="close_edit_dialog()"-->

     <!--      />-->
     <!--   </div>-->

     <!--</v-dialog>-->





     <!--<v-dialog-->
     <!--    v-model="dialog_delete_grade"-->
     <!--    max-width="420"-->
     <!--&gt;-->
     <!--   <v-card>-->
     <!--      <v-card-title class="headline">Confirm Delete Grade?</v-card-title>-->

     <!--      <v-card-text>-->
     <!--         Are you sure you want to delete this graded lead?-->
     <!--      </v-card-text>-->

     <!--      <v-card-actions>-->
     <!--         <v-btn color="red" text @click="delete_graded_lead(del_grade_id)">Delete</v-btn>-->
     <!--         <v-spacer></v-spacer>-->
     <!--         <v-btn text @click="close_del_confirm">Cancel</v-btn>-->
     <!--      </v-card-actions>-->
     <!--   </v-card>-->
     <!--</v-dialog>-->







     <v-dialog v-model="editCoachup" max-width="1200px" persistent >
        <div style="background-color: white">
           <div style="justify-content: flex-end; display: flex; margin-bottom: -20px">
              <v-btn icon @click="close_edit_dialog()">
                 <v-icon>close</v-icon>
              </v-btn>
           </div>
           <grade-coach-up
               v-if=" editCoachup"
               :coachup_id="selectedCoachup._id"
               @close="close_edit_dialog()"

           />
        </div>

     </v-dialog>








    <section-definition title="Manager Teacher" >
    </section-definition>

    <v-container fluid grid-list-xl page>
      <v-layout row wrap>

         <v-flex class="ml-4" style="max-width: 150px">
            <v-autocomplete
                v-model="coachup_status"
                label="Coach Up Type"
                dense
                hide-details
                :items="['All', 'Coached']"
                @change="on_change_top_inputs"
            />
         </v-flex>



        <v-flex grow></v-flex>



        <v-flex xs4 sm4 md2>
          <v-menu
              v-model="date_menu1"
              :close-on-content-click="false"
              :nudge-right="0"
              lazy
              transition="scale-transition"
              offset-y
              :nudge-bottom="0"
              full-width
              max-width="290px"
              min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                      v-model="selected_date_begin"
                      label="Begin Range"
                      hint="YYYY-MM-DD format"
                      prepend-icon="event"
                      v-on="on"
                      v-on:change="on_change_top_inputs"
              ></v-text-field>
            </template>
            <v-date-picker
                    v-model="selected_date_begin"
                    no-title
                    @input="date_menu1 = false"
                    v-on:change="on_change_top_inputs"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs4 sm4 md2>
          <v-menu
                  v-model="date_menu2"
                  :close-on-content-click="false"
                  :nudge-right="0"
                  lazy
                  transition="scale-transition"
                  offset-y
                  :nudge-bottom="0"
                  full-width
                  max-width="290px"
                  min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                      v-model="selected_date_end"
                      label="End Range"
                      hint="YYYY-MM-DD format"
                      prepend-icon="event"
                      v-on="on"

              ></v-text-field>
            </template>
            <v-date-picker
                    v-model="selected_date_end"
                    no-title
                    @input="date_menu2 = false"
                    v-on:change="on_select_dealership"
            ></v-date-picker>
          </v-menu>
        </v-flex>


         <v-flex xs12 sm4 md2>

            <v-autocomplete
                label="Organization"
                :items="orgs"
                item-value="_id"
                item-text="name"
                v-model="selected_org_id"
                v-on:change="on_org_change"
            >
            </v-autocomplete>

         </v-flex>


         <v-flex xs12 sm6 md3>

            <v-autocomplete
                label="Dealership"
                :items="dealerships"
                item-value="_id"
                item-text="name"
                v-model="selectedDealership"
                v-on:change="on_select_dealership"
                clearable
            >
            </v-autocomplete>

         </v-flex>

        <!-- -->
        <!--<v-flex xs12 sm6 md4>-->

        <!--  <v-autocomplete-->
        <!--          label="Organization/Dealership"-->
        <!--          :items="dealerships"-->
        <!--          item-value="_id"-->
        <!--          item-text="txt"-->
        <!--          v-model="selectedDealership"-->
        <!--          v-on:change="on_select_dealership"-->
        <!--  >-->
        <!--  </v-autocomplete>-->

        <!--</v-flex>-->
      </v-layout>


      <v-container fluid grid-list-md page>




        <!------------------------------list of individual coach ups ------------------------------------------------>
        <v-layout >
          <v-flex xs12>
            <v-card>
              <v-toolbar color="transparent" flat>
                <v-toolbar-title>Sales Manager Ranking</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <!-- <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> -->
              <v-card-text class="text-xs-left">

                <v-data-table
                    :headers="gl_headers"
                    :items="managerRanking"
                    :pagination.sync="gl_pagination"
                >
                  <template slot="items" slot-scope="props" >
                     <!--v-on:click="view_this_grade(props.item)"  style="cursor:pointer;"-->
                    <!--<tr-->
                    <!--     :style="is_draft(props.item)? 'background-color:yellow':''"-->
                    <!--&gt;-->

                     <tr
                     >

                       <!--<td style="white-space: nowrap">{{ props.item.grade_id.info_lead.lead_arrived_date }}</td>-->
                       <td style="white-space: nowrap">{{ props.item.coach.name }}</td>
                        <td style="white-space: nowrap">{{ props.item.coachups }}</td>
                        <td style="white-space: nowrap">{{ round(props.item.percentOfTotal*100, 0) }}%</td>


                       <!--<td style="white-space: nowrap">{{ props.item.coachee.name }}</td>-->
                       <!--&lt;!&ndash;<td style="white-space: nowrap">{{ props.item.grade_id.curriculum.name }}</td>&ndash;&gt;-->
                       <!--<td style="white-space: nowrap">{{ props.item.grade_id.grade_letter }}</td>-->
                       <!--&lt;!&ndash;<td style="white-space: nowrap">{{ round(props.item.grade_id.grade_score, 1) }}</td>&ndash;&gt;-->
                       <!--<td style="">{{ props.item.grade_id.info_customer.name_first +' ' + props.item.grade_id.info_customer.name_last}}</td>-->
                       <!--<td>{{ props.item.grade_id.info_lead.wanted_vehicle }}</td>-->
                       <!--<td>{{ truncate_str(props.item.grade_id.comments_external) }}</td>-->


                       <!--<td>-->
                       <!--   <v-btn flat :color="!is_finished(props.item) ? 'accent': ''" small class="ma-0" @click="view_this_grade(props.item.grade_id)">-->
                       <!--     Review Grade-->
                       <!--   </v-btn>-->

                       <!--   &lt;!&ndash;:to="'/coachup?coachup_id='+props.item._id"&ndash;&gt;-->
                       <!--   <v-btn-->
                       <!--       v-if="!is_finished(props.item)"-->
                       <!--       flat color="accent" small class="ma-0"-->

                       <!--       @click="edit_this_coachup(props.item)"-->
                       <!--   >-->
                       <!--      Coach-Up-->
                       <!--   </v-btn>-->
                       <!--   <v-btn-->
                       <!--       v-else-->
                       <!--       flat  small class="ma-0"  @click="view_this_coachup(props.item)">-->
                       <!--      View Coachup-->
                       <!--   </v-btn>-->

                       <!--</td>-->

                    </tr>
                  </template>
                </v-data-table>








              </v-card-text>
              </v-card>

          </v-flex>

        </v-layout>







      </v-container> <!--main container-->
    </v-container>











  </div>
</template>


<style scoped>
  .grade-card{
    font-size: xx-large;
    font-weight: bolder;
    /*color: black;*/
  }

  .row_style{
    text-align: left;
    border: none !important;
    font-size: large;
  }

  .txt-center{
      text-align: center;
  }

 div >>> td{
      padding-left: 7px !important;
      padding-right: 7px !important;
  }

  div >>> th{
      padding-left: 7px !important;
      padding-right: 7px !important;
  }
</style>


<script>
   import axios from 'axios';
   const moment = require('moment');
   import viewGrade from '../components/viewGrade.vue';
   import editGrade from "@/views/Curricula/GradeLead";
   import GradeCoachUp from "@/views/Curricula/GradeCoachUp";
   import data_getters from '../mixins/data_getters';
   import _ from 'lodash';

   import {DateTime} from 'luxon';
   import ViewCoachup from "@/components/viewCoachup";

   // function findWithAttr(array, attr, value) {
   //    for(var i = 0; i < array.length; i += 1) {
   //       if(array[i][attr] === value) {
   //          return i;
   //       }
   //    }
   //    return -1;
   // }



export default {
      name: 'CoachupRanking',
   components:{
      ViewCoachup,
      viewGrade, GradeCoachUp
   },

   mixins: [data_getters],

  data() {
     return {
        letter_grades: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'F'],
        date_menu1: false,
        date_menu2: false,
        selected_date_begin : moment().subtract(90, 'days').format('YYYY-MM-DD'),
        selected_date_end   : moment().format('YYYY-MM-DD'),
        show_finished: false, //controls if all coachup or just the non-finished ones are shown
        coachup_status: 'Coached', //for status drop down in nav bar


        orgs: [],
        selected_org_id: null,

        dealerships: [],
        selectedDealership: null,
        salesPeople: [],
        selectedSalesPerson: null,

        // grade_dealership: {},
        // grades_salesPeople: [],
        // sp_graded_leads: [],

        coach_ups: [],

        cu_ranking: [],
        managerRanking: [],

        selectedLead: null,
        showGrade: false,

        selectedCoachup: null,
        editCoachup: false,
        showViewCoachup: false,

        sp_headers: [
           // {text: '', value: 'picture', width: '5%'},
           {text: 'Sales Person', value: 'name',},
           {text: 'Dealership', value: 'dealership',},
           {text: 'Curriculum', value: 'curriculum.name', },
           {text: 'Avg Grade', value: 'avg_grade_ix', },
           // {text: 'Avg Score', value: 'avg_score', width: '20%'},
           {text: '# Leads', value: 'count', },
        ],

        sp_pagination: {
           sortBy: 'avg_grade_ix', // The field that you're sorting by
           descending: false,
           rowsPerPage: -1
        },




        gl_headers_non_admin: [
           // {text: 'Date In', value: 'grade_id.date_graded', },
           {text: 'Manager/Coach', value: 'coach.name', },
           {text: 'Num Coach-ups', value: 'coachups', },
           {text: 'Percent of all coachups', value: 'percentOfTotal', },


           {text: '', value: '',},
        ],

        gl_headers_admin: [

           {text: 'Manager/Coach', value: 'coach.name', },
           {text: 'Num Coach-ups', value: 'coachups', },
           {text: 'Percent of all coachups', value: 'percentOfTotal', },

        ],


        dialog_delete_grade: false,
        del_grade_id: null,


        gl_pagination: {
           sortBy: 'percentOfTotal', // The field that you're sorting by
           descending: true,
           rowsPerPage: -1
        },

        page: {
           title: "Report Card",
        },

     };
  },
  methods:{


     //simple function to tell if a grade is a draft or not.  needed since we added the date_email field on 3/1/2021
     is_draft(lead) {

        // console.log({lead})
        // if (DateTime.fromISO(lead.date_graded) < DateTime.fromISO('2021-02-23T00:00:00')) {
        //    return false;
        // }

        return  (lead.emailed_users === null);
        // {
        //    return 'background-color: #ffffff';
        // } // note this needs to be an exact match to handle the case of date_emailed not being defined
     },


     is_finished(coachup){
       return _.get(coachup, 'emailed_users.date', null) !== null;
     },

     get_val(obj, name, def=null){
        return _.get(obj, name, def)
     },


     async on_org_change(){
        this.selectedDealership = null;
        this.dealerships = await this.get_dealers({org_id: this.selected_org_id});
        await this.get_cu_rankings();
     },



     async get_dealers_local(){


        try {
           // let {data} = await axios.get(url, token);
           this.dealerships = await this.get_dealers();

           for (let i=0; i<this.dealerships.length; i++){
              let d = this.dealerships[i];
              if (d.org_id){
                 this.dealerships[i].txt = d.org_id.name +' / '+d.name;
              }
              else{
                 this.dealerships[i].txt ='No Group/'+d.name;
              }
           }//for i

           this.dealerships = this.dealerships.sort((a, b) => (a.txt > b.txt) ? 1 : -1);


        }
        catch(err){
           console.log(err);
           // ans = err.response.data;
        }
     },



     on_change_top_inputs(){
       if (this.sp_mode){
          this.get_graded_leads_local(this.selectedSalesPerson.user_id)
       } else{
          this.on_select_dealership();
       }
     },


     async on_select_dealership(){


        console.log('debug')

        try{

           await this.get_cu_rankings()

        }catch (e) {
           console.error(e);
        }



     },

     //
     // async on_select_salesPerson(sp){
     //    this.selectedSalesPerson = sp;
     //
     //    await this.get_graded_leads_local(sp.user_id)
     // },

     view_this_grade(grade){
        console.log('debug')
        this.selectedLead = grade;
        this.showGrade=true;


     },




     async delete_graded_lead( grade_id){
        console.log('grade', grade_id)
        let {token, query} = await this.base_user_request();
        let url = this.$baseUrlApi + '/deleteGradedLead';

        query.grade_id = grade_id;


        try {

           let res = await axios.post(url, {query }, token);
           this.dialog_delete_grade = false;
           this.del_grade_id = null;



           this.get_graded_leads_local(this.selectedSalesPerson.user_id).catch(e =>{
              console.error(e);
           })

        }
        catch(err){
           console.log(err);

        }
     },

     del_grade(grade){

        this.del_grade_id = grade._id;
        this.dialog_delete_grade = true;
     },

     close_del_confirm(){
        this.dialog_delete_grade = false;
        this.del_grade_id = null;
     },


     // async get_graded_leads_local(user_id){
     //
     //    if (user_id == null){
     //       user_id = this.selectedSalesPerson.user_id;
     //    }
     //
     //
     //    let dateRange = {begin: this.selected_date_begin, end: this.selected_date_end };
     //
     //    console.log('debug')
     //    try {
     //       this.sp_graded_leads = await this.get_graded_leads({user_id, dateRange,
     //          dealer_id: this.selectedDealership == null? undefined: this.selectedDealership,
     //          org_id: this.selected_org_id, get_player_data: 'percent'});
     //
     //
     //       console.log('i ran')
     //    }
     //    catch(err){
     //       console.log(err);
     //       // ans = err.response.data;
     //    }
     // },



     async get_cu_rankings(){

        this.loading_team = true;
        console.log('get_cu_rankings')

        // if (this.selectedDealership === undefined)
        //    return;


        let {token, query} = await this.base_user_request();
        let url = this.$baseUrlApi + '/getCoachupReport';


        query.status = this.coachup_status;


        let payload, payload2;
        if (this.selectedDealership){
           query.org_id = this.selected_org_id;
           query.dealer_id = this.selectedDealership;

           payload = {
              match: query,
              dateRange: {begin: this.selected_date_begin, end: this.selected_date_end },
              // groupby: 'dealership',
              // user_role: 'SalesPerson',
           };


        }


        else{
           delete query.dealer_id;
           query.org_id = this.selected_org_id;

           payload = {
              match: query,
              dateRange: {begin: this.selected_date_begin, end: this.selected_date_end },
              // groupby: 'organization',
              // user_role: 'SalesPerson',
           };

        }


        console.log({payload, payload2, query})



        try {
           if (this.selectedDealership || true){
              let {data} = await axios.post(url, payload, token);

              this.cu_ranking = data;
              this.managerRanking = data.coachups;

              // if (data.length===1){
              //    this.grade_dealership = data[0];
              // }
              // else{
              //    this.grade_dealership = {avg_grade_ix: -1}
              // }
              //
              //


           }

        }
        catch(err){
           console.log(err);
           this.avg_grade_ix = -1;

        }

     },





     gradeIxToLetter(ix){
        if (ix>-1){
           return this.letter_grades[Math.round(ix)];
        }
        else{
           return 'N/A';
        }
     },

     get_grade_color(grade){
        let ans;
        switch (grade.charAt(0)){
           case 'A':
              ans =  '#00C853';
              break;
           case 'B':
              ans =  '#F9A825';
              break;
           case 'C':
              ans =  '#F9A825';
              break;
           case 'D':
              ans =  '#D50000';
              break;
           case 'F':
              ans =  '#D50000';
              break;
           case 'N':
              ans =  '#9E9E9E';
              break;

        }
        return ans;
     },

     edit_this_coachup(coachup){
        this.selectedCoachup = coachup;
        this.editCoachup = true;
     },

     view_this_coachup(coachup){
        this.selectedCoachup = coachup;
        this.showViewCoachup = true;
     },

     close_view_coachup_dialog(){
        this.editCoachup=false;
        this.selectedCoachup=null;
     },

     close_edit_dialog(){

        this.editCoachup=false;
        this.selectedCoachup=null;
        this.get_cu_rankings();
     }



  },
   computed: {
     sp_mode(){
        return this.$auth.profile.user_role === 'SalesPerson';
     },

      show_graded_leads(){
        if (this.$auth.profile.user_role !== 'SalesPerson'){
           return !!this.selectedSalesPerson;
        }
        else{
           return true;
        }

      },

      gl_headers(){

         // this.$auth.profile.user_role === 'Admin' &&
         if (this.$auth.profile.acct_type === 'AGENCY'){
            return this.gl_headers_admin;
         }
         else{
            return this.gl_headers_non_admin;
         }
      },

      overall_grade_card_txt(){
        if (this.selectedDealership == null){
           return 'Organization Grade';
        }
        else{
           return 'Dealership Grade';
        }
      },

      isAdmin(){
         return (this.$auth.profile.acct_type === 'AGENCY' && this.$auth.profile.user_role === 'Admin' )
      }

   },

  async created(){

      this.orgs = await this.get_organizations();


      if (this.orgs.length>0){
         this.selected_org_id = this.orgs[0]._id;
      }
     await this.on_org_change();



     // await this.get_dealers_local();

     // if (this.dealerships[0]){
     //    this.selectedDealership = this.dealerships[0]._id;
     //    await this.on_select_dealership();
     // }

     // if (this.sp_mode){
     //    this.selectedSalesPerson = this.$auth.profile;
     //    this.selectedDealership = this.dealerships[0]._id;
     //    await this.get_graded_leads_local(this.$auth.profile.user_id);
     // }


  }
};
</script>
